import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a1019892ab6ae001410b9cf_1779867860968/iaclimbboard/src/app/components/LeaderboardPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a1019892ab6ae001410b9cf_1779867860968/iaclimbboard/src/components/Topbar.tsx");
